/**
 * Team Block JavaScript
 */

(function () {
  "use strict";

  // Initialize block functionality
  function initTeam() {
    const blocks = document.querySelectorAll(".team");

    blocks.forEach((block) => {
      initTeamSlider(block);
    });
  }

  /**
   * Initialize team slider
   */
  function initTeamSlider(block) {
    const sliderContainer = block.querySelector(".team_inner_slider");
    const arrowsWrapper = block.querySelector(".team_slider_arrows_wrapper");
    const prevBtn = arrowsWrapper
      ? arrowsWrapper.querySelector(".carousel-arrow--prev")
      : null;
    const nextBtn = arrowsWrapper
      ? arrowsWrapper.querySelector(".carousel-arrow--next")
      : null;

    if (!sliderContainer) return;

    const members = Array.from(
      sliderContainer.querySelectorAll(".team_member")
    );
    if (members.length === 0) return;

    let currentIndex = 0;
    let itemsPerView = 1; // Mobile default

    // Get items per view based on screen size
    function getItemsPerView() {
      if (window.innerWidth >= 1024) {
        return 3; // Desktop
      } else if (window.innerWidth >= 768) {
        return 2; // Tablet
      }
      return 1; // Mobile
    }

    // Calculate max index based on items per view
    function getMaxIndex() {
      const itemsToShow = getItemsPerView();
      return Math.max(0, members.length - itemsToShow);
    }

    // Update slider position
    function updateSliderPosition() {
      itemsPerView = getItemsPerView();
      const maxIndex = getMaxIndex();

      // Clamp currentIndex to valid range
      if (currentIndex > maxIndex) {
        currentIndex = maxIndex;
      }

      // Calculate the width of one item including gap
      const firstMember = members[0];
      if (!firstMember) return;

      const memberWidth = firstMember.offsetWidth;
      const gap = 35; // Gap between items
      const itemWidthWithGap = memberWidth + gap;

      // Calculate translateX value
      const translateX = -currentIndex * itemWidthWithGap;

      // Apply transform
      sliderContainer.style.transform = `translateX(${translateX}px)`;

      // Update arrow states
      updateArrows();
    }

    // Update arrow states
    function updateArrows() {
      const maxIndex = getMaxIndex();

      if (prevBtn) {
        prevBtn.disabled = currentIndex === 0;
        prevBtn.classList.toggle("disabled", currentIndex === 0);
      }

      if (nextBtn) {
        nextBtn.disabled = currentIndex >= maxIndex;
        nextBtn.classList.toggle("disabled", currentIndex >= maxIndex);
      }
    }

    // Next slide
    function nextSlide() {
      const maxIndex = getMaxIndex();
      if (currentIndex < maxIndex) {
        currentIndex++;
        updateSliderPosition();
      }
    }

    // Previous slide
    function prevSlide() {
      if (currentIndex > 0) {
        currentIndex--;
        updateSliderPosition();
      }
    }

    // Event listeners
    if (nextBtn) {
      nextBtn.addEventListener("click", nextSlide);
    }

    if (prevBtn) {
      prevBtn.addEventListener("click", prevSlide);
    }

    // Handle window resize
    let resizeTimeout;
    window.addEventListener("resize", () => {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(() => {
        updateSliderPosition();
      }, 100);
    });

    // Initialize
    updateSliderPosition();

    // Hide arrows if not enough items
    if (members.length <= getItemsPerView()) {
      if (prevBtn) prevBtn.style.display = "none";
      if (nextBtn) nextBtn.style.display = "none";
    }
  }

  // Initialize on DOM ready
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initTeam);
  } else {
    initTeam();
  }
})();
